import React, { Fragment, useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { AppContext } from "../../components/AppProvider";
import { checkNum10, ckeckAmPm } from "../../modules/utils/CheckLogic";
import { IC } from "../../resources/Assets";
import { openLayerFn } from "../Layout";
import { commonFileUpload } from "../PersonalMedicalRecords/PmrLayout";

export default props => {
  const {
    mapLayer,
    settingSeqNo,
    calendar,
    schdlList,
    handleDialog,
    mode,
    keyName,
    periodState,
  } = props;

  const { ref, inView } = useInView();

  const [lastIndex, setLastIndex] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [deleteState, setDeleteState] = useState(false);

  const CPP = 20;

  const styleNoCalendar = {
    paddingTop: "60px",
    padding: "30px 0px",
  };
  const styleCalendar = {
    paddingTop: "30px",
    padding: "30px 0px",
  };

  useEffect(() => {
    const tList =
      schdlList &&
      Array.isArray(schdlList) &&
      schdlList.filter(
        (i, index) => index >= (lastIndex - 1) * CPP && index < lastIndex * CPP
      );

    if (deleteState) {
      setDisplayList(tList);
      setDeleteState(false);
    } else {
      setDisplayList([...(displayList ?? []), ...(tList ?? [])]);
    }
  }, [lastIndex, schdlList]);

  useEffect(() => {
    if (!schdlList || !Array.isArray(schdlList)) return;
    else if (inView && lastIndex * CPP < schdlList.length) {
      setLastIndex(lastIndex + 1);
    }
  }, [inView]);

  return (
    <div
      className="calendar-reser-date"
      style={!calendar ? styleNoCalendar : styleCalendar}>
      <div className="time-schedule-list calen">
        {schdlList.map((list, i) => (
          <ListComponent
            key={keyName + i}
            mapLayer={mapLayer}
            settingSeqNo={settingSeqNo}
            info={list}
            handleDialog={handleDialog}
            mode={mode}
            seqNo={i}
            periodState={periodState}
            newDate={
              i > 0
                ? schdlList[i].schdlDh.split(" ")[0] ===
                  schdlList[i - 1].schdlDh.split(" ")[0]
                  ? false
                  : true
                : true
            }
          />
        ))}
      </div>
      <div ref={ref} />
    </div>
  );
};

const ListComponent = props => {
  const {
    mapLayer,
    settingSeqNo,
    info,
    handleDialog,
    mode,
    newDate,
    seqNo,
    periodState,
  } = props;
  const [tipOn, setTipOn] = useState(false);
  const [imgArray, setImgArray] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const { userinfo } = useContext(AppContext);
  //  삭제, 수정 추가

  // 메모 화면
  const openDetail = title => {
    // 설정 데이터 셋팅필요
    $("#customTitle").val(title);
    // state 속성으로 삭제 버튼 유/무 확인 - 다른방법도 체크
    // 설정 팝업 OPEN
    openLayerFn($(".add-date-layer"));
  };

  const changeDate = (orgDate, target) => {
    let orgDt = orgDate.split(" ");
    let changeDt = orgDt;
    let returnDt;

    changeDt = new Date(
      orgDt[0].split(".")[0] +
        "-" +
        orgDt[0].split(".")[1] +
        "-" +
        orgDt[0].split(".")[2]
    );

    if (target == "D") {
      returnDt =
        changeDt.getFullYear() +
        "." +
        checkNum10(changeDt.getMonth() + 1) +
        "." +
        checkNum10(changeDt.getDate());
    }

    if (target == "T") {
      if (orgDt[1]) {
        returnDt =
          ckeckAmPm(orgDt[1].split(":")[0]) +
          " " +
          checkNum10(
            parseInt(orgDt[1].split(":")[0]) > 12
              ? parseInt(orgDt[1].split(":")[0]) - 12
              : parseInt(orgDt[1].split(":")[0])
          ) +
          ":" +
          checkNum10(parseInt(orgDt[1].split(":")[1]));
      }
    }

    return returnDt;
  };

  const checkName = param => {
    let rtnValue = param;

    // 병원명이 5글자 이상인경우 3글자+...표시
    if (rtnValue.length >= 5) {
      rtnValue = rtnValue.substring(0, 3) + "...";
    }

    return rtnValue;
  };

  let deadLine = new Date();
  deadLine = new Date(deadLine.setMinutes(new Date().getMinutes() - 30));

  const onClickDrop = target => {
    $(target).parent().parent().parent().toggleClass("on");
    $(target).parent().parent().next(".inthe-box").slideToggle("fast");

    if ($(target).parent().parent().parent().hasClass("on")) {
      var currentSctop = $(target).parent().parent().parent().offset().top - 20;
      $("html, body").stop().animate({ scrollTop: currentSctop }, 400);
    }
  };

  const viewNotiImg = schdlSeqNo => {
    // reloadList, userinfo, trsmId, bizDtlType, view, bizType, bizName
    commonFileUpload(
      "",
      userinfo,
      schdlSeqNo,
      2,
      "Y",
      "PS",
      "검사유의사항",
      "",
      ""
    );
  };

  useEffect(() => {
    if (modalVisible) {
      document.body.style.overflow = "hidden";
      $(".wrap .btn-backpage").hide();
    } else {
      document.body.style.overflow = "unset";
      $(".wrap .btn-backpage").show();
    }
  }, [modalVisible]);

  return (
    <div
      className="reserv"
      style={{
        paddingLeft: "0px",
      }}>
      <div
        className="allselect-box"
        style={{
          padding: "0px",
        }}>
        <div className="check-dotguide">
          {newDate === true && (
            <label className="check-box">{changeDate(info.schdlDh, "D")}</label>
          )}

          {/* 툴팁 */}
          {seqNo === 0 && periodState === "F" && (
            <Fragment>
              <div className="tooltip">
                <span>
                  <svg
                    className="tooltip-icon"
                    style={{ width: "22px", height: "22px" }}>
                    <use
                      xlinkHref="#question_mark"
                      onClick={() => setTipOn(true)}
                    />
                  </svg>
                </span>

                <span
                  className="tooltip-content"
                  style={
                    tipOn ? { visibility: "visible" } : { visibility: "hidden" }
                  }
                  onClick={() => setTipOn(false)}>
                  <img
                    src={IC.schedule.IC_SCHEDULE_WATING}
                    viewBox="0 0 24 24"
                  />
                  <span>가예약</span>
                  <img
                    src={IC.schedule.IC_SCHEDULE_CONFIRM}
                    style={{ marginLeft: "8px" }}
                    viewBox="0 0 24 24"
                  />
                  <span>예약확정</span>
                  <img
                    src={IC.schedule.IC_SCHEDULE_CANCEL}
                    style={{ marginLeft: "8px" }}
                    viewBox="0 0 24 24"
                  />
                  <span>예약취소</span>
                </span>
              </div>

              <svg
                xmlns='http://www.w3.org/2000/svg"'
                style={{ display: "none" }}>
                <symbol id="question_mark" viewBox="0 0 24 24">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645z"
                    fill="currentColor"></path>
                </symbol>
              </svg>
            </Fragment>
          )}
          {/* 툴팁 */}
        </div>
      </div>

      <div
        className="infobox"
        name={info.schdlDh.split(" ")[0]}
        id={"info" + info.schdlDh.split(" ")[0]}
        style={
          // info.cnclYn === "N" && periodState === "F"
          info.timeType === "F"
            ? { paddingBottom: "14px" }
            : { paddingBottom: "14px", opacity: "0.4" }
        }>
        <div className="check-dotguide">
          {
            <label
              className="check-box"
              onClick={() => settingSeqNo(info.schdlSeqNo)}>
              <input
                type="checkbox"
                name="checkSeqNo"
                value={info.schdlSeqNo}
              />
              <i></i>
              <div
                style={{
                  width: "4px",
                  height: "20px",
                  margin: "0px 4px 3px 0",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              />
              {info.schdlDh.split(" ")[1] && (
                <span className="ins-time">
                  {changeDate(info.schdlDh, "T")}
                </span>
              )}
            </label>
          }

          <div className="ins-hos-name">
            <span>
              {info.hsptNm}
              <a
                className="location-pin"
                onClick={() =>
                  mapLayer({
                    latitude: info.lat,
                    longitude: info.long,
                    hpName: info.hsptNm,
                    address3: info.address3,
                    address4: info.address4,
                    phone: info.telNo,
                  })
                }
              />
            </span>
          </div>
        </div>

        <div className="check-inspection">
          <a className="icon-ins-state">
            {info.schdlStat === "R" &&
              info.delYn === "N" &&
              info.cnclYn === "N" && (
                <img
                  src={IC.schedule.IC_SCHEDULE_WATING}
                  alt="아이콘-예약대기"
                />
              )}
            {info.schdlStat === "F" &&
              info.delYn === "N" &&
              info.cnclYn === "N" && (
                <img
                  src={IC.schedule.IC_SCHEDULE_CONFIRM}
                  alt="아이콘-예약확정"
                />
              )}
            {
              // info.schdlStat === "F" && info.delYn === "Y"
              info.cnclYn === "Y" && (
                <img
                  src={IC.schedule.IC_SCHEDULE_CANCEL}
                  alt="아이콘-취소완료"
                />
              )
            }

            <div className="ins-name">{info.schdlNm}</div>
            <span
              className="btn-dropdown"
              id={"memo" + info.schdlSeqNo}
              onClick={() => onClickDrop("#memo" + info.schdlSeqNo)}></span>
          </a>
        </div>

        <div className="inthe-box">
          <hr className="inthe-dash" />
          <h4 style={{ textAlign: "center" }}>안내사항</h4>
          <span style={{ wordBreak: "break-all" }}>
            <br />
            {info.notiDesc
              ? info.notiDesc
              : "예약관련 안내사항은 병원에 문의해주세요."}
          </span>
        </div>

        {(info.fileCnt > 0 || info.timeType === "F") && (
          <div className="check-precaution">
            {/* 일단 보류 */}
            {info.fileCnt > 0 && (
              <a
                className="icon-dash"
                onClick={() => viewNotiImg(info.schdlSeqNo)}>
                <img
                  src={IC.schedule.IC_SCHEDULE_DASH}
                  style={{ paddingRight: "10px" }}
                />
                <span className="txt">
                  검사유의사항
                  {info.fileCnt > 0 && (
                    <img
                      src={IC.etc.IC_INSPEC}
                      style={{ position: "absolute" }}
                    />
                  )}
                </span>
              </a>
            )}

            {
              // 확정예약인 경우만 예약취소 버튼 나오도록 2022-10-06 요청
              info.timeType === "F" &&
                (info.cnclYn === "N" ? (
                  <div
                    className="btn_basic_violet"
                    onClick={() =>
                      handleDialog(
                        "검사예약취소",
                        "취소된 예약은 다시 되돌릴 수 없습니다.<br /> 정말 취소하시겠습니까?",
                        "cancel",
                        {
                          schdlSeqNo: info.schdlSeqNo,
                          hsptCd: info.hsptCd,
                          schdlNo: info.schdlNo,
                        }
                      )
                    }>
                    <span>
                      <a>예약취소</a>
                    </span>
                  </div>
                ) : (
                  <div
                    style={{
                      position: "absolute",
                      right: "12px",
                      marginTop: info.notiDesc == "" ? "" : "-15px",
                    }}>
                    <span>
                      <a>취소된 예약입니다</a>
                    </span>
                  </div>
                ))
            }
          </div>
        )}
      </div>
    </div>
  );
};

const RsvStatus = props => {
  const { openDetail, schdlStat } = props;

  // const styleStatusIng = {
  //     width:"64px"
  //     , marginTop:"-28px"
  //     , fontSize:"10px"
  //     , top:"58%"
  // }

  const styleStatusIng = {
    width: "64px",
    marginTop: "10px",
    fontSize: "10px",
    top: "0%",
    backgroundImage: IC.schedule.IC_SCHEDULE_HOLD,
  };

  const styleStatusEnd = {
    width: "52px",
    top: "58%",
    marginTop: "7px",
    fontSize: "10px",
    right: "16px",
  };

  const styleArrowDown = {
    height: "8px",
    position: "absolute",
    top: "50%",
    marginTop: "-4px",
    right: "36px",
  };

  return (
    <Fragment>
      {/* <i className={schdlStat === "F" ? "" : "cmCustom"} style={styleStatusIng}>
                {schdlStat === "F" ? "예약 완료" : "예약 대기중"}
            </i> */}
      {/* <i className={schdlStat === "F" ? "" : "cmCustom"} style={styleStatusEnd}>예약 완료</i> */}

      <img
        src={
          schdlStat === "F"
            ? IC.schedule.IC_SCHEDULE_COMPLETE_ON
            : IC.schedule.IC_SCHEDULE_HOLD
        }
        style={{
          width: "30px",
          position: "absolute",
          right: "10px",
          marginTop: "5px",
        }}
      />
    </Fragment>
  );
};

export const ButtonRound = props => {
  const { text, style, handleDialog, tell } = props;

  return (
    <div style={style} onClick={() => handleDialog("", "", "", tell)}>
      {text}
    </div>
  );
};

export const ButtonNotice = () => {
  const style = {
    width: "100%",
    textAlign: "center",
    backgroundColor: "#cccccc",
    padding: "8px 0px",
    borderRadius: "8px",
    marginTop: "4px",
    marginBottom: "8px",
    color: "#000",
    fontSize: "12px",
  };

  return <div style={style}>유의사항</div>;
};
